import { FilterFieldInterface } from '@app/interfaces/_index';
import { Adapter } from './adapter';
import { FilterField } from '@app/models/filter-field.model';

export class FilterObjectAdapter implements Adapter<FilterField> {
  /**
   * Adapt course data item into a FilterField model.
   * @param item - data item FilterField Interface to be transformed
   * @returns - returns an adapted FilterField model
   */
  adapt(item: FilterFieldInterface): FilterField {
    let filterField: FilterField;
    if (item && item.data) {
      filterField = new FilterField(
        item?.data?.id,
        item?.data?.name,
        item?.data?.additional_fields
      );
    }
    return filterField;
  }
}
